import jordanPeterson from '../images/jordan-peterson.png'
import feynman from '../images/feynman.png'
import bigmagic from '../images/bigmagic.png'
import onething from '../images/onething.png'
import lessons from '../images/lessons.png'
import sogood from '../images/sogood.png'
import cosmos from '../images/cosmos.png'
import obstacle from '../images/obstacle.png'

const libraryData = [
  {
    title: '12 Rules For Life',
    author: 'Jordan Peterson',
    screenshot: jordanPeterson,
    quote:
      '"Rule 4: Compare yourself to who you were yesterday, not to who someone else is today."',
    page:
      'https://www.amazon.com/12-Rules-Life-Antidote-Chaos-ebook/dp/B01FPGY5T0/ref=sr_1_1?ie=UTF8&qid=1542416698&sr=8-1&keywords=12+rules+for+life',
  },
  {
    title: "Surely You're Joking, Mr. Feynman!",
    author: 'Richard Feynman',
    screenshot: feynman,
    quote:
      '"The highest forms of understanding we can achieve are laughter and human compassion."',
    page:
      'https://www.amazon.com/Surely-Youre-Joking-Mr-Feynman/dp/0393355624/ref=sr_1_1?s=books&ie=UTF8&qid=1542416754&sr=1-1&keywords=surely+you%27re+joking+mr.+feynman',
  },
  {
    title: 'Big Magic',
    author: 'Elizabeth Gilbert',
    screenshot: bigmagic,
    quote:
      '"The universe buries strange jewels deep within us all, and then stands back to see if we can find them."',
    page:
      'https://www.amazon.com/Big-Magic-Creative-Living-Beyond-ebook/dp/B00S52M350/ref=sr_1_1?s=books&ie=UTF8&qid=1542416776&sr=1-1&keywords=Big+Magic',
  },
  {
    title: 'The ONE Thing',
    author: 'Gary Keller',
    screenshot: onething,
    quote:
      '"What’s the one thing you can do, such that by doing it, everything else will be easier or unnecessary?"',
    page:
      'https://www.amazon.com/ONE-Thing-Surprisingly-Extraordinary-Results-ebook/dp/B00C1BHQXK/ref=sr_1_3?s=books&ie=UTF8&qid=1542416793&sr=1-3&keywords=The+one+thing',
  },
  {
    title: '21 Lessons for the 21st Century',
    author: 'Yuval Noah Harari',
    screenshot: lessons,
    quote: '"In a world deluged by irrelevant information, clarity is power."',
    page:
      'https://www.amazon.com/Lessons-21st-Century-Yuval-Harari-ebook/dp/B079WM7KLS/ref=sr_1_1?s=books&ie=UTF8&qid=1542416809&sr=1-1&keywords=21+lesson',
  },
  {
    title: "So Good They Can't Ignore You",
    author: 'Cal Newport',
    screenshot: sogood,
    quote:
      '"If you’re not uncomfortable, then you’re probably stuck at an "acceptable level."',
    page:
      'https://www.amazon.com/Good-They-Cant-Ignore-You-ebook/dp/B0076DDBJ6/ref=sr_1_1?s=books&ie=UTF8&qid=1542416823&sr=1-1&keywords=So+Good+They+Can%27t+Ignore+You',
  },
  {
    title: 'Cosmos',
    author: 'Carl Sagan',
    screenshot: cosmos,
    quote:
      '"If you wish to make an apple pie from scratch, you must first invent the universe."',
    page:
      'https://www.amazon.com/Cosmos-Carl-Sagan-ebook/dp/B004W0HZN4/ref=sr_1_1?s=books&ie=UTF8&qid=1542416841&sr=1-1&keywords=cosmos+carl+sagan',
  },
  {
    title: 'The Obstacle is the Way',
    author: 'Ryan Holiday',
    screenshot: obstacle,
    quote:
      '"Focus on the moment, not the monsters that may or may not be up ahead."',
    page:
      'https://www.amazon.com/Obstacle-Way-Timeless-Turning-Triumph-ebook/dp/B00G3L1B8K/ref=sr_1_2?s=books&ie=UTF8&qid=1542416857&sr=1-2&keywords=The+Obstacle+is+the+Way',
  },
]

export default libraryData
